import { APP_PARAM_TYPES } from "constant/application.js";
import PropTypes from "prop-types";

const PropSelectOptions = PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.node.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }),
);

const PropAppParamV3Schema = PropTypes.shape({
  data_type: PropTypes.oneOf(APP_PARAM_TYPES),
  default_value: PropTypes.any,
  description: PropTypes.string,
  display_name: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string),
  required: PropTypes.bool,
});

const PropFormikField = PropTypes.shape({
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.any,
});

export { PropAppParamV3Schema, PropFormikField, PropSelectOptions };
